<!--
  Custom icon: Menu Tree (hierarchy)
  Usage (single-color, like any Element Plus icon):
    <el-icon :size="20" color="#409eff"><IconMenuTree /></el-icon>
    <el-icon><IconMenuTree /></el-icon>

  The SVG root element has no fixed color — it inherits `currentColor`
  from the parent <el-icon> wrapper, exactly like @element-plus/icons-vue.
-->
<template>
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <!-- Root node -->
    <rect x="8" y="1" width="8" height="5" rx="1.5" fill="currentColor" opacity="0.9" />
    <!-- Vertical stem -->
    <line x1="12" y1="6" x2="12" y2="10" stroke="currentColor" stroke-width="1.5" />
    <!-- Horizontal bar -->
    <line x1="5" y1="10" x2="19" y2="10" stroke="currentColor" stroke-width="1.5" />
    <!-- Left branch drop -->
    <line x1="5" y1="10" x2="5" y2="13" stroke="currentColor" stroke-width="1.5" />
    <!-- Middle branch drop -->
    <line x1="12" y1="10" x2="12" y2="13" stroke="currentColor" stroke-width="1.5" />
    <!-- Right branch drop -->
    <line x1="19" y1="10" x2="19" y2="13" stroke="currentColor" stroke-width="1.5" />
    <!-- Left leaf -->
    <rect x="1.5" y="13" width="7" height="4.5" rx="1" fill="currentColor" opacity="0.75" />
    <!-- Middle leaf -->
    <rect x="8.5" y="13" width="7" height="4.5" rx="1" fill="currentColor" opacity="0.75" />
    <!-- Right leaf -->
    <rect x="15.5" y="13" width="7" height="4.5" rx="1" fill="currentColor" opacity="0.75" />
  </svg>
</template>
